import React, { useEffect, useState, useRef } from 'react';
import { Table, Space, Tooltip, Modal, Input } from 'antd';
import { Button, FormField, InfoMessage } from 'components';
import { updateFormField } from 'store/forms/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as WarningV2 } from 'assets/icons/warning-red-v2.svg';
import { StatusTag } from 'components';
import { ReactComponent as ActionsIcon } from '../../../../../../assets/icons/more_dots.svg';
import Popover from '@mui/material/Popover';
import SupplierActionList from './SupplierActionList';
import {
  supplierUpdateVoucher,
  sendOtpVoucher,
  getVoucher,
} from 'store/forms/actions';
import { equipmentDocs } from '../equipmentDocs';
import RedeemModal from '../../redeemModal';
import { isSupplier, isVoucherViewer } from 'utils';
import { isNil } from 'lodash';

const SupplierEquipmentInfo = ({
  disableVoucherTabs,
  disableAction,
  simulation,
}) => {
  const dispatch = useDispatch();
  const legalVat = useSelector(state => state.forms.carrier.legalVat);
  const supplier = useSelector(state => state.forms?.supplier);
  const error = useSelector(state => state.forms?.supplier?.error);
  const voucherInfo = useSelector(state => state.forms?.supplier?.voucherInfo);
  const otpVoucher = useSelector(state => state.forms?.otpVoucher);
  const ean = useSelector(state => state.forms?.supplier?.ean);
  const compositeEan = useSelector(
    state => state.forms?.supplier?.compositeEan
  );

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [open, setOpen] = useState(Boolean(anchorEl));
  const [otpModal, setOtpModal] = useState(false);
  const [genericModal, setGenericModal] = useState(false);
  const [openReedemModal, setOpenReedemModal] = useState(false);
  const [openRedeemOverwriteModal, setOpenRedeemOverwriteModal] =
    useState(false);
  const [openVerificatioModal, setOpenVerificatioModal] = useState(false);

  const [isCompleteOtpCode, setIsCompleteOtpCode] = useState(false);
  const inputs = useRef([
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef(),
    useRef(),
  ]);
  const [otpValues, setOtpValues] = useState(Array(6).fill(''));
  const [attachments, setAttachments] = useState([]);
  const [errorModal, setErrorModal] = useState(false);
  const user = useSelector(state => state.user);
  const hideActions =
    isVoucherViewer(user?.groups) ||
    (isSupplier(user?.groups) &&
      (voucherInfo?.voucher?.status === 'PAID' ||
        voucherInfo?.voucher?.status === 'PAYMENT_FAILED'));

  // console.log("groups:", groups);
  // console.log("isVoucherViewer:", isVoucherViewer(groups));
  const columns = [
    {
      title: 'Αριθμός Voucher Εξοπλισμού',
      dataIndex: 'code',
      key: 'code',
      width: '15%',
      render: () => (
        <p className="color-blue-3 text-bold mt-1">
          {voucherInfo?.voucher?.code}
        </p>
      ),
    },
    {
      title: 'Υπαγωγή',
      dataIndex: 'numberAffiliation',
      key: 'numberAffiliation',
      fixed: 'center',
      align: 'center',
      render: () => (
        <p className="mt-1">
          {!isNil(voucherInfo?.voucher?.numberAffiliation)
            ? voucherInfo?.voucher?.numberAffiliation
            : '-'}
        </p>
      ),
      width: '5%',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      width: '20%',
      render: () => (
        <div className="status-tag-wrapper">
          <StatusTag id={''} status={voucherInfo?.voucher?.status} />
        </div>
      ),
    },
    {
      title: 'Status Αξιολόγησης',
      dataIndex: 'auditStatus',
      key: 'auditStatus',
      align: 'center',
      width: '20%',
      render: () => (
        <div className="status-tag-wrapper">
          <StatusTag id={''} status={voucherInfo?.voucher?.auditStatus} />
        </div>
      ),
    },
    {
      title: 'Κωδικός Προϊόντος',
      dataIndex: 'ean',
      key: 'ean',
      width: '20%',
      render: () => (
        <FormField
          type="text"
          size="medium"
          disabled={disableVoucherTabs}
          placeholder="Επιλέξτε Κωδικό Προϊόντος"
          className="like-text"
          value={
            voucherInfo?.voucher?.status === 'AVAILABLE'
              ? ean
              : voucherInfo?.voucher?.ean
          }
          onChange={event =>
            dispatch(
              updateFormField({
                group: 'supplier',
                key: 'ean',
                value: event.target.value,
              })
            )
          }
        />
      ),
    },
    {
      title: (
        <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          Εξοπλισμός σύνθεσης
          <InfoMessage
            infoMessage={
              'Το δεύτερο ΕΑΝ συμπληρώνεται μόνο στην περίπτωση που ο τελικός εξοπλισμός αποτελεί προϊόν σύνθεσης, όπως για παράδειγμα boiler–συλλέκτης ή πολυδιαιρούμενες αντλίες θερμότητας'
            }
            overlayClassName="multiline-info-message"
            placement="right"
          />
        </div>
      ),
      dataIndex: 'compositeEan',
      key: 'compositeEan',
      width: '25%',
      render: () => (
        <FormField
          type="text"
          size="medium"
          disabled={disableVoucherTabs || !ean}
          placeholder="Κωδικός Εξοπλ. Σύνθεσης"
          className="like-text"
          value={
            voucherInfo?.voucher?.status === 'AVAILABLE'
              ? compositeEan
              : voucherInfo?.voucher?.compositeEan
          }
          onChange={event =>
            dispatch(
              updateFormField({
                group: 'supplier',
                key: 'compositeEan',
                value: event.target.value,
              })
            )
          }
        />
      ),
    },

    {
      title: '',
      key: 'action',
      align: 'right',
      width: '5%',
      render: (text, record) => {
        if (hideActions) return null;
        return (
          <Space id="action-cell-1">
            <Tooltip title="Actions">
              <div
                className="action-icon-voucher"
                onClick={e => onMoreClick(record.id, record.businessKey)(e)}
              >
                <ActionsIcon aria-describedby="simple-popover" />
              </div>
            </Tooltip>
          </Space>
        );
      },
    },
  ];

  //----------------------------  ACTIONS HANDLES -------------------------------\\
  const onMoreClick = () => event => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  //----------------------------  OTP HANDLES -------------------------------\\

  const handleChangeOtp = (e, index) => {
    const value = e.target.value;
    if (!/^\d*$/.test(value)) return; // only allow digits

    const newOtpValues = [...otpValues];
    newOtpValues[index] = value;
    setOtpValues(newOtpValues);

    if (value && index < inputs.current.length - 1) {
      inputs.current[index + 1].current.focus();
    }

    const code = newOtpValues.join('');

    //Checks for 6 digits opt input so to enable Verify button
    setIsCompleteOtpCode(code.length === 6 && /^\d{6}$/.test(code));
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !otpValues[index] && index > 0) {
      inputs.current[index - 1].current.focus();
    }
  };

  //----------------------------  RESERVE ACTION -------------------------------\\
  const handleVerify = () => {
    const code = otpValues.join('');

    const payload = {
      otp: code,
      voucherCode: voucherInfo?.voucher?.code || '',
      vatId: legalVat,
      ean: ean || '',
      compositeEan: compositeEan || '',
      basePrice: voucherInfo?.voucher?.basePrice,
      baseVat: voucherInfo?.voucher?.baseVat,
      additionalCosts: voucherInfo?.voucher?.additionalCosts,
      additionalCostsVat: voucherInfo?.voucher?.additionalCostsVat,
      nonSubsidizedEquipmentCost:
        voucherInfo?.voucher?.nonSubsidizedEquipmentCost,
      nonSubsidizedEquipmentCostVat:
        voucherInfo?.voucher?.nonSubsidizedEquipmentCostVat,
      action: 'RESERVE',
    };
    console.log('payload sent to supplierUpdateVoucher', payload);
    dispatch(supplierUpdateVoucher({ simulation: false, params: payload }));
  };

  //----------------------------  RELEASE ACTION -------------------------------\\
  const handleRelease = () => {
    const parameters = {
      voucherCode: voucherInfo?.voucher?.code || '',
      vatId: legalVat,
    };

    const payload = {
      voucherCode: voucherInfo?.voucher?.code || '',
      vatId: legalVat,
      ean: ean || '',
      compositeEan: compositeEan || '',
      action: 'RELEASE',
    };

    dispatch(
      supplierUpdateVoucher({ simulation: false, params: payload, parameters })
    );
  };

  useEffect(() => {
    if (!error && supplier) {
      setOtpModal(false);
      setGenericModal(false);
      setOpenReedemModal(false);
      setOpenRedeemOverwriteModal(false);
      setOpenVerificatioModal(false);
    }
  }, [error, supplier]);

  const handleCloseOtpModal = () => {
    setOtpModal(false);
    setOtpValues(Array(6).fill(''));
    setIsCompleteOtpCode(false);

    // Reset focus (optional)
    inputs.current.forEach(ref => {
      if (ref.current) ref.current.blur();
    });

    if (error) {
      dispatch(
        updateFormField({
          group: 'supplier',
          key: 'error',
          value: null,
        })
      );
      dispatch(
        updateFormField({
          group: 'otpVoucher',
          value: null,
        })
      );
    }
  };

  const onResendOtp = () => {
    const params = {
      voucherCode: voucherInfo?.voucher?.code,
      vatId: legalVat,
    };
    dispatch(sendOtpVoucher(params));
  };

  useEffect(() => {
    if (error) {
      if (!simulation) setErrorModal(true);
    }
  }, [error]);

  const handleCloseError = () => {
    setErrorModal(false);
    if (error) {
      dispatch(
        updateFormField({
          group: 'supplier',
          key: 'error',
          value: null,
        })
      );
    }
  };

  return (
    <>
      <Modal
        centered
        width={400}
        open={errorModal}
        onCancel={() => setErrorModal(false)}
        onOk={() => setErrorModal(false)}
        closable={false}
        footer={null}
        maskClosable={false}
      >
        <div className="mt-2 mb-2 color-red" style={{ textAlign: 'center' }}>
          <WarningV2 />
          <p>{error?.responseDescription}</p>
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            type="default"
            className={'ant-btn-primary return-btn'}
            label={'Κλείσιμο'}
            onClick={handleCloseError}
          />
        </div>
      </Modal>

      {/* RESERVE - OTP MODAL */}
      <Modal
        centered
        width={544}
        open={otpModal}
        onCancel={handleCloseOtpModal}
        onOk={() => setOtpModal(false)}
        closable={true}
        footer={null}
        maskClosable={false}
      >
        <h2
          className={'font-size-30'}
          style={{ marginTop: 15, textAlign: 'center' }}
        >
          Επιβεβαίωση Χρήστη
        </h2>
        <p style={{ textAlign: 'center' }}>
          Εισάγεται τον 6ψήφιο κωδικό που λάβατε στο κινητό σας τηλέφωνο
        </p>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            margin: '20px 0',
          }}
        >
          {otpValues.map((value, i) => (
            <Input
              key={i}
              maxLength={1}
              value={value}
              onChange={e => handleChangeOtp(e, i)}
              onKeyDown={e => handleKeyDown(e, i)}
              style={{
                width: 50,
                height: 50,
                textAlign: 'center',
                fontSize: 24,
                background: '#91C8F3',
              }}
              ref={inputs.current[i]}
            />
          ))}
        </div>
        {otpVoucher && otpVoucher?.responseCode !== '600' && (
          <div className="mt-2 mb-2 color-red" style={{ textAlign: 'center' }}>
            <p>{otpVoucher.responseDescription}</p>
          </div>
        )}
        {error && (
          <div className="mt-2 mb-2 color-red" style={{ textAlign: 'center' }}>
            <p>{error.responseDescription}</p>
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            type="default"
            className={'ant-btn-primary verify-btn'}
            label={'Επιβεβαίωση'}
            disabled={!isCompleteOtpCode}
            onClick={handleVerify}
          />
        </div>
        <div className={'bold'} style={{ marginTop: 15, textAlign: 'center' }}>
          Δεν λάβατε κωδικό;{' '}
          <a
            href="#"
            onClick={() => {
              onResendOtp();
            }}
          >
            Επαναποστολή
          </a>
        </div>
      </Modal>

      {/* RELEASE MODAL */}
      <Modal
        centered
        width={400}
        open={genericModal}
        onCancel={() => setGenericModal(false)}
        onOk={() => setGenericModal(false)}
        closable={false}
        footer={null}
      >
        <WarningV2 />
        <h2 className={'font-size-18'} style={{ marginTop: 10 }}>
          Αποδέσμευση Voucher
        </h2>
        <p style={{ textAlign: 'left' }}>
          Είστε βέβαιος/-η ότι επιθυμείτε να αποδεσμεύσετε το voucher;
        </p>
        <p style={{ textAlign: 'left' }}>
          Κατόπιν αυτής της ενέργειας το voucher θα είναι εκ νέου διαθέσιμο για
          τον ωφελούμενο
        </p>
        <p style={{ textAlign: 'left' }}>Η ενέργεια είναι μη αναστρέψιμη.</p>
        {error && (
          <div className="mt-2 mb-2 color-red" style={{ textAlign: 'center' }}>
            <p>{error.responseDescription}</p>
          </div>
        )}
        <div className="modal-buttons-container">
          <Button
            type="default"
            className={'ant-btn-primary return-btn'}
            label={'Επιστροφή'}
            onClick={() => setGenericModal(false)}
          />
          <Button
            disabled={error}
            type="default"
            className={'ant-btn-primary reject-btn-2'}
            label={'Αποδέσμευση'}
            onClick={handleRelease}
          />
        </div>
      </Modal>

      {/* REDEEM MODAL */}
      <RedeemModal
        docs={equipmentDocs}
        error={error}
        openReedemModal={openReedemModal}
        setOpenReedemModal={setOpenReedemModal}
        openRedeemOverwriteModal={openRedeemOverwriteModal}
        setOpenRedeemOverwriteModal={setOpenRedeemOverwriteModal}
        openVerificatioModal={openVerificatioModal}
        setOpenVerificatioModal={setOpenVerificatioModal}
        attachments={attachments}
        setAttachments={setAttachments}
      />

      {/* ACTIONS POPOVER */}
      <Popover
        id={'action-cell-1'}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <SupplierActionList
          open={setOpen}
          setOpen={setOpen}
          setOtpModal={setOtpModal}
          setGenericModal={setGenericModal}
          setOpenReedemModal={setOpenReedemModal}
          setOpenRedeemOverwriteModal={setOpenRedeemOverwriteModal}
          voucherInfo={voucherInfo}
          legalVat={legalVat}
          disableAction={disableAction}
        />
      </Popover>

      <div className="voucher-info-table">
        <Table
          columns={columns}
          dataSource={[voucherInfo?.voucher]}
          pagination={false}
          bordered={false}
          rowClassName={() => 'custom-row'}
        />
      </div>
    </>
  );
};

export default SupplierEquipmentInfo;
